import toast from 'react-hot-toast';

export const toastMessage = (message, type = 'success') => {
  switch (type) {
    case 'success':
      toast.success(message, {
        duration: 4000,
        position: 'top-right',
      });
      break;
    case 'error':
      toast.error(message, {
        duration: 4000,
        position: 'top-right',
      });
      break;
    case 'loading':
      toast.loading(message, {
        duration: 4000,
        position: 'top-right',
      });
      break;
    case 'warning':
      toast(message, {
        icon: '⚠️',
        duration: 4000,
        position: 'top-right',
      });
      break;
    default:
      toast(message, {
        duration: 4000,
        position: 'top-right',
      });
  }
};

export default toastMessage;
